"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockMenu = void 0;
var mockMenu = {
  menuTypes: [{
    menuItems: [{
      calories: 0,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_CustomBanner',
        imageURL: 'https://lcemedia.littlecaesars.com/custompizza/CYO_RegLg.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 0,
      itemCaloriesText: '',
      itemDescription: '',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Create Your Own Pizza',
      itemName: 'Create Your Own Pizza',
      itemType: 'CUS',
      maxToppings: 0,
      menuItemCode: 'BNR-CUS',
      menuWarnings: null,
      orderable: true,
      price: 0,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }],
    itemType: 'CUS',
    typeDescription: 'Create Your Own Pizza'
  }, {
    menuItems: [{
      calories: 2130,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/95bc83b8-396c-453a-b306-8311931de036.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/95bc83b8-396c-453a-b306-8311931de036.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201100,
      itemCaloriesText: '2130 Cal',
      itemDescription: 'Large thin crust pizza topped right to the edge with Pepperoni and Cheese.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Thin Crust Pepperoni (2130 Cal)',
      itemName: 'Thin Crust Pepperoni',
      itemType: 'LTO',
      maxToppings: 0,
      menuItemCode: 'EMB-TPEP',
      menuWarnings: null,
      orderable: true,
      price: 7.49,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1980,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d42e7dcb-ea78-45ef-b31b-61bc94929db0.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d42e7dcb-ea78-45ef-b31b-61bc94929db0.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201108,
      itemCaloriesText: '1980 Cal',
      itemDescription: 'Large thin crust pizza topped right to the edge with Cheese.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Thin Crust Cheese (1980 Cal)',
      itemName: 'Thin Crust Cheese',
      itemType: 'LTO',
      maxToppings: 0,
      menuItemCode: 'HNR-THINCHS',
      menuWarnings: null,
      orderable: true,
      price: 7.49,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 3810,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f531c530-5fa5-478f-9d88-c458a6002803.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f531c530-5fa5-478f-9d88-c458a6002803.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601111,
      itemCaloriesText: '3810 Cal',
      itemDescription: 'Thin Crust Pepperoni pizza, Crazy Combo® and a 2-liter PEPSI®.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Thin Crust Meal Deal with Pepsi® (3810 Cal)',
      itemName: 'Thin Crust Meal Deal with Pepsi®',
      itemType: 'LTO',
      maxToppings: 0,
      menuItemCode: 'EMB-COMBOTCPEP',
      menuWarnings: null,
      orderable: true,
      price: 11.99,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2960,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/9d142344-d787-4948-84b4-851c37b53624.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/9d142344-d787-4948-84b4-851c37b53624.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601111,
      itemCaloriesText: '2960 Cal',
      itemDescription: 'Thin Crust Pepperoni pizza, Crazy Combo® and a 2-liter Diet PEPSI®.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Thin Crust Meal Deal with Diet Pepsi® (2960 Cal)',
      itemName: 'Thin Crust Meal Deal with Diet Pepsi®',
      itemType: 'LTO',
      maxToppings: 0,
      menuItemCode: 'EMB-COMBOTCDPEP',
      menuWarnings: null,
      orderable: true,
      price: 11.99,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 3920,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/81629afe-20a7-443b-8120-6c59ca35b38c.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/81629afe-20a7-443b-8120-6c59ca35b38c.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601111,
      itemCaloriesText: '3920 Cal',
      itemDescription: 'Thin Crust Pepperoni pizza, Crazy Combo® and a 2-liter Mountain Dew®.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Thin Crust Meal Deal with Mountain Dew® (3920 Cal)',
      itemName: 'Thin Crust Meal Deal with Mountain Dew®',
      itemType: 'LTO',
      maxToppings: 0,
      menuItemCode: 'EMB-COMBOTCMDEW',
      menuWarnings: null,
      orderable: true,
      price: 11.99,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 3750,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/305fdee2-343f-4f46-8adf-d34e5b8d7b06.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/305fdee2-343f-4f46-8adf-d34e5b8d7b06.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601111,
      itemCaloriesText: '3750 Cal',
      itemDescription: 'Thin Crust Pepperoni pizza, Crazy Combo® and a 2-liter Sierra Mist®.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Thin Crust Meal Deal with Sierra Mist® (3750 Cal)',
      itemName: 'Thin Crust Meal Deal with Sierra Mist®',
      itemType: 'LTO',
      maxToppings: 0,
      menuItemCode: 'EMB-COMBOTCMT',
      menuWarnings: null,
      orderable: true,
      price: 11.99,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 800,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/cc2e2c53-ee15-430c-b90a-b04820316319.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/cc2e2c53-ee15-430c-b90a-b04820316319.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 101289,
      itemCaloriesText: '800 Cal',
      itemDescription: 'Brownie topped with Cookie Dough Frosting and TWIX® Cookie Bar Pieces | 4-piece order',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Cookie Dough Brownie made with TWIX® Cookie Bar Pieces (800 Cal)',
      itemName: 'Cookie Dough Brownie made with TWIX® Cookie Bar Pieces',
      itemType: 'LTO',
      maxToppings: 0,
      menuItemCode: 'HNRS-KDBTWX',
      menuWarnings: null,
      orderable: true,
      price: 3.89,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 840,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e7741f5f-e5e1-4b59-a395-c6e6714c1a44.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e7741f5f-e5e1-4b59-a395-c6e6714c1a44.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 101288,
      itemCaloriesText: '840 Cal',
      itemDescription: 'Brownie topped with Cookie Dough Frosting and M&M’S® MINIS Chocolate Candies | 4-piece order',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Cookie Dough Brownie made with M&M’S® MINIS Chocolate Candies (840 Cal)',
      itemName: 'Cookie Dough Brownie made with M&M’S® MINIS Chocolate Candies',
      itemType: 'LTO',
      maxToppings: 0,
      menuItemCode: 'HNRS-CDBMM',
      menuWarnings: null,
      orderable: true,
      price: 3.89,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }],
    itemType: 'LTO',
    typeDescription: 'Limited Time Offer'
  }, {
    menuItems: [{
      calories: 3000,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/fbf13920-e9b1-4024-8788-5ee19c820e78.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/fbf13920-e9b1-4024-8788-5ee19c820e78.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201342,
      itemCaloriesText: '3000 Cal',
      itemDescription: 'Four slices of Pepperoni pizza combined with eight Italian Cheese Stix, plus Crazy Sauce®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Slices-N-Stix® (3000 Cal)',
      itemName: 'Slices-N-Stix®',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-SNS',
      menuWarnings: null,
      orderable: true,
      price: 6.5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2130,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/95bc83b8-396c-453a-b306-8311931de036.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/95bc83b8-396c-453a-b306-8311931de036.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201100,
      itemCaloriesText: '2130 Cal',
      itemDescription: 'Large thin crust pizza topped right to the edge with Pepperoni and Cheese.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Thin Crust Pepperoni (2130 Cal)',
      itemName: 'Thin Crust Pepperoni',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-TPEP',
      menuWarnings: null,
      orderable: true,
      price: 7.49,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1980,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d42e7dcb-ea78-45ef-b31b-61bc94929db0.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d42e7dcb-ea78-45ef-b31b-61bc94929db0.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201108,
      itemCaloriesText: '1980 Cal',
      itemDescription: 'Large thin crust pizza topped right to the edge with Cheese.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Thin Crust Cheese (1980 Cal)',
      itemName: 'Thin Crust Cheese',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'HNR-THINCHS',
      menuWarnings: null,
      orderable: true,
      price: 7.49,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2980,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/079c3f2b-3b20-4f81-a675-4f9a921f2e4e.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/079c3f2b-3b20-4f81-a675-4f9a921f2e4e.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201138,
      itemCaloriesText: '2980 Cal',
      itemDescription: 'Large round pizza with more Pepperoni and Cheese than our Classic pizza baked into the crust.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Stuffed Crust Pepperoni (2980 Cal)',
      itemName: 'Stuffed Crust Pepperoni',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-SCPEP',
      menuWarnings: null,
      orderable: true,
      price: 9,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 3340,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/bce6b83b-f0e8-4ed0-8f15-74fefcf5a961.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/bce6b83b-f0e8-4ed0-8f15-74fefcf5a961.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 101229,
      itemCaloriesText: '3340 Cal',
      itemDescription: 'A large ExtraMostBestest® pepperoni pizza with pepperoni and cheese stuffed in a parmesa.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Pepperoni & Cheese Stuffed Crust (3340 Cal)',
      itemName: 'Pepperoni & Cheese Stuffed Crust',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-PCSCPEP',
      menuWarnings: null,
      orderable: true,
      price: 10,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2830,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/90c26a69-f3bc-45b7-b845-0076e9b36a80.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/90c26a69-f3bc-45b7-b845-0076e9b36a80.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201150,
      itemCaloriesText: '2830 Cal',
      itemDescription: 'CRAZY!CRAZY!™ AMOUNTS OF Sausage, Smoky Ham, Pepperoni and Seasoned Beef',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: '5 Meat Feast™ (2830 Cal)',
      itemName: '5 Meat Feast™',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-5MFP',
      menuWarnings: null,
      orderable: true,
      price: 9,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2510,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/676b0279-baf7-4cac-8b79-e5b43794263c.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/676b0279-baf7-4cac-8b79-e5b43794263c.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201004,
      itemCaloriesText: '2510 Cal',
      itemDescription: 'CRAZY!CRAZY!™ AMOUNT Pepperoni, Italian Sausage, Mushrooms, Onions, and Green Peppers',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Ultimate Supreme (2510 Cal)',
      itemName: 'Ultimate Supreme',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-USP',
      menuWarnings: null,
      orderable: true,
      price: 8,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2870,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/ddb6c649-0722-41d3-a267-c98ed7ec0990.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/ddb6c649-0722-41d3-a267-c98ed7ec0990.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201003,
      itemCaloriesText: '2870 Cal',
      itemDescription: 'CRAZY!CRAZY!™ AMOUNTS OF TOPPINGS AT THE NATION Pepperoni, Italian Sausage and Bacon',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: '3 Meat Treat® (2870 Cal)',
      itemName: '3 Meat Treat®',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-3MT',
      menuWarnings: null,
      orderable: true,
      price: 8,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2180,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/54825eb3-5d4e-46e0-a821-df3e352d247b.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/54825eb3-5d4e-46e0-a821-df3e352d247b.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201002,
      itemCaloriesText: '2180 Cal',
      itemDescription: 'CRAZY!CRAZY!™ AMOUNTS OF TOPPINGS am and Pineapple',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Hula Hawaiian® (2180 Cal)',
      itemName: 'Hula Hawaiian®',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-HHP',
      menuWarnings: null,
      orderable: true,
      price: 10,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2240,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/70d38673-402a-433a-9127-79c8da501062.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/70d38673-402a-433a-9127-79c8da501062.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201008,
      itemCaloriesText: '2240 Cal',
      itemDescription: 'CRAZY!CRAZY!™ AMOUNTS OF TOPnd pizza with Green Peppers, Onions, Mushroom Seasoning',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Veggie (2240 Cal)',
      itemName: 'Veggie',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-VEGP',
      menuWarnings: null,
      orderable: true,
      price: 8,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2220,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/4de86567-b9e3-4820-a177-9a84facbca8e.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/4de86567-b9e3-4820-a177-9a84facbca8e.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201128,
      itemCaloriesText: '2220 Cal',
      itemDescription: 'Large round pizza with more Cheese than our Classic pizza.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'ExtraMostBestest® Cheese (2220 Cal)',
      itemName: 'ExtraMostBestest® Cheese',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-CHS',
      menuWarnings: null,
      orderable: true,
      price: 6.55,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2500,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e2986457-18c4-4f98-bf60-d7f29ca67763.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e2986457-18c4-4f98-bf60-d7f29ca67763.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201106,
      itemCaloriesText: '2500 Cal',
      itemDescription: 'Large round pizza with more Pepperoni and Cheese than our Classic pizza.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'ExtraMostBestest® Pepperoni (2500 Cal)',
      itemName: 'ExtraMostBestest® Pepperoni',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-PEP',
      menuWarnings: null,
      orderable: true,
      price: 6.55,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2660,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/3af1ea88-eeec-4978-bff4-45c8c9389b6a.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/3af1ea88-eeec-4978-bff4-45c8c9389b6a.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201129,
      itemCaloriesText: '2660 Cal',
      itemDescription: 'Large round with Italian Sausage',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'ExtraMostBestest® Italian Sausage (2660 Cal)',
      itemName: 'ExtraMostBestest® Italian Sausage',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'EMB-SAU',
      menuWarnings: null,
      orderable: true,
      price: 6,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2270,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/7a8ac0b0-3691-4167-856c-d3ec0ede9284.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/7a8ac0b0-3691-4167-856c-d3ec0ede9284.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201001,
      itemCaloriesText: '2270 Cal',
      itemDescription: 'Large round pizza with Italian Sausage',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Classic Italian Sausage (2270 Cal)',
      itemName: 'Classic Italian Sausage',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'HNR-SAU',
      menuWarnings: null,
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2300,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e6a09afe-58ec-4e24-9c52-c92c764cf0d1.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e6a09afe-58ec-4e24-9c52-c92c764cf0d1.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 101001,
      itemCaloriesText: '2300 Cal',
      itemDescription: 'Large round pizza with Pepperoni',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Classic Pepperoni (2300 Cal)',
      itemName: 'Classic Pepperoni',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'HNR-PEP',
      menuWarnings: null,
      orderable: true,
      price: 5.55,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1950,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/3dfae2da-c3d1-418c-ae5b-fb08511315d3.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/3dfae2da-c3d1-418c-ae5b-fb08511315d3.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 101002,
      itemCaloriesText: '1950 Cal',
      itemDescription: 'Large round pizza with Cheese',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Classic Cheese (1950 Cal)',
      itemName: 'Classic Cheese',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'HNR-CHS',
      menuWarnings: null,
      orderable: true,
      price: 5.55,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2260,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e0094c2a-70e4-43b4-a5c7-8fc482baee79.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e0094c2a-70e4-43b4-a5c7-8fc482baee79.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 202011,
      itemCaloriesText: '2260 Cal',
      itemDescription: 'Large round pizza with pepperoni and jalapeño peppers.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Pepperoni and Jalapeño (2260 Cal)',
      itemName: 'Pepperoni and Jalapeño',
      itemType: 'LRP',
      maxToppings: 0,
      menuItemCode: 'HNR-PJP',
      menuWarnings: null,
      orderable: true,
      price: 7.75,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }],
    itemType: 'LRP',
    typeDescription: 'Large Round Pizzas'
  }, {
    menuItems: [{
      calories: 3050,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/2e2806a5-e567-410a-9e05-690b2ccdcb00.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/2e2806a5-e567-410a-9e05-690b2ccdcb00.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 402208,
      itemCaloriesText: '3050 Cal',
      itemDescription: 'Large Detroit-Style Deep Dish Pizza with Pepperoni, Italian Sausage, Mushrooms, Onions and Green Peppers',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Detroit-Style Deep Dish Ultimate Supreme (3050 Cal)',
      itemName: 'Detroit-Style Deep Dish Ultimate Supreme',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-DDDUSP',
      menuWarnings: null,
      orderable: true,
      price: 11,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 3480,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/9c0d7aa9-abda-469f-b1f9-5b827d12e47f.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/9c0d7aa9-abda-469f-b1f9-5b827d12e47f.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201059,
      itemCaloriesText: '3480 Cal',
      itemDescription: 'Large Detroit-Style Deep Dish Pizza with Pepperoni, Italian Sausage and Bacon',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Detroit-Style Deep Dish 3 Meat Treat® (3480 Cal)',
      itemName: 'Detroit-Style Deep Dish 3 Meat Treat®',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-DDD3MT',
      menuWarnings: null,
      orderable: true,
      price: 11,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2770,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/63eafc86-494e-4d40-8cc5-7dcf4f95d514.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/63eafc86-494e-4d40-8cc5-7dcf4f95d514.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201042,
      itemCaloriesText: '2770 Cal',
      itemDescription: 'Large Detroit-Style Deep Dish Pizza with Pepperoni',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Detroit-Style Deep Dish Pepperoni (2770 Cal)',
      itemName: 'Detroit-Style Deep Dish Pepperoni',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-DDSP',
      menuWarnings: null,
      orderable: true,
      price: 8,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2820,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/159bed55-5034-4cce-8b35-d3ccaca64151.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/159bed55-5034-4cce-8b35-d3ccaca64151.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201044,
      itemCaloriesText: '2820 Cal',
      itemDescription: 'Large Detroit-Style Deep Dish Pizza with Italian Sausage',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Detroit-Style Deep Dish Sausage (2820 Cal)',
      itemName: 'Detroit-Style Deep Dish Sausage',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-DDIS',
      menuWarnings: null,
      orderable: true,
      price: 8,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2500,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Pizza',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/2c65e2dc-1d9c-468c-9a31-8bc07ba8d0ff.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/2c65e2dc-1d9c-468c-9a31-8bc07ba8d0ff.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 201043,
      itemCaloriesText: '2500 Cal',
      itemDescription: 'Large Detroit-Style Deep Dish Pizza with Cheese',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Detroit-Style Deep Dish Cheese (2500 Cal)',
      itemName: 'Detroit-Style Deep Dish Cheese',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-DDCH',
      menuWarnings: null,
      orderable: true,
      price: 8,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1390,
      caloriesRange: '1465 – 1530',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/82921d01-509f-49b6-a0c8-d5cfe9c7a8a9.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/82921d01-509f-49b6-a0c8-d5cfe9c7a8a9.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601001,
      itemCaloriesText: '1465 – 1530 Cal',
      itemDescription: 'Four slices of Detroit-style deep dish pizza with Pepperoni visit http://www.pepsicobeveragefacts.com/',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: '$5 Lunch Combo (1465 – 1530 Cal)',
      itemName: '$5 Lunch Combo',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-SSL',
      menuWarnings: [{
        id: 'Sodium',
        name: 'Sodium',
        url: 'https://mobileblobfiles.blob.core.windows.net/menuwarningimages/NYC-sodium-warning-label-lg.jpg',
        altText: 'High Sodium',
        displayOrder: 0,
        warningText: 'Warning indicates that the sodium (salt) daily (2,300 mg).ressure and risk of heart disease and stroke'
      }],
      orderable: false,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1640,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/aa3902a1-2698-44ab-a292-54dcf0973cc7.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/aa3902a1-2698-44ab-a292-54dcf0973cc7.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601001,
      itemCaloriesText: '1640 Cal',
      itemDescription: 'Four slices of Detroit-Style Deep Dish Pizza with Pepperoni and one  20 oz',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: '$5 Lunch Combo Pepsi (1640 Cal)',
      itemName: '$5 Lunch Combo Pepsi',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-SSLP',
      menuWarnings: [{
        id: 'Sodium',
        name: 'Sodium',
        url: 'https://mobileblobfiles.blob.core.windows.net/menuwarningimages/NYC-sodium-warning-label-lg.jpg',
        altText: 'High Sodium',
        displayOrder: 0,
        warningText: 'Warning indicates that the sodium (salt) content of this item is daily recommended limit and stroke'
      }],
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1680,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/90b3fe01-ef14-4168-8b69-3ea9502eecd6.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/90b3fe01-ef14-4168-8b69-3ea9502eecd6.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601001,
      itemCaloriesText: '1680 Cal',
      itemDescription: 'Four slices of Detroit-Style Deep Dish Pizza visit https://www.pepsicobeveragefacts.com/home/find#/',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: '$5 Lunch Combo Mountain Dew (1680 Cal)',
      itemName: '$5 Lunch Combo Mountain Dew',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-SSLMDEW',
      menuWarnings: [{
        id: 'Sodium',
        name: 'Sodium',
        url: 'https://mobileblobfiles.blob.core.windows.net/menuwarningimages/NYC-sodium-warning-label-lg.jpg',
        altText: 'High Sodium',
        displayOrder: 0,
        warningText: 'Warning indicates that the sodium (salt) content intake can increase  of heart disease and stroke'
      }],
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1630,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/78ec455b-9c77-4d22-851d-6ce4fe108d14.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/78ec455b-9c77-4d22-851d-6ce4fe108d14.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601001,
      itemCaloriesText: '1630 Cal',
      itemDescription: 'Four slices of oz. PEPSI-COLA® product. For PEPSI-COLA® nutrition',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: '$5 Lunch Combo Sierra Mist (1630 Cal)',
      itemName: '$5 Lunch Combo Sierra Mist',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-SSLMT',
      menuWarnings: [{
        id: 'Sodium',
        name: 'Sodium',
        url: 'https://mobileblobfiles.blob.core.windows.net/menuwarningimages/NYC-sodium-warning-label-lg.jpg',
        altText: 'High Sodium',
        displayOrder: 0,
        warningText: 'Warning indicates that the sodium (salt) content of this item is higher than the total'
      }],
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1390,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/1972c5ec-6456-4ca3-a783-f157ee8cfd64.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/1972c5ec-6456-4ca3-a783-f157ee8cfd64.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601001,
      itemCaloriesText: '1390 Cal',
      itemDescription: 'Four slices of Detroit-Style Deep Dish Pizza with',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: '$5 Lunch Combo Diet Pepsi (1390 Cal)',
      itemName: '$5 Lunch Combo Diet Pepsi',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-SSLDP',
      menuWarnings: [{
        id: 'Sodium',
        name: 'Sodium',
        url: 'https://mobileblobfiles.blob.core.windows.net/menuwarningimages/NYC-sodium-warning-label-lg.jpg',
        altText: 'High Sodium',
        displayOrder: 0,
        warningText: 'Warning indicates that the sodium (salt) content of this item is higher than'
      }],
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1390,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/1c75d76f-b45f-468c-92f2-7012a4f67489.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/1c75d76f-b45f-468c-92f2-7012a4f67489.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601030,
      itemCaloriesText: '1390 Cal',
      itemDescription: 'Four slices of Detroit-Style Deep Dish Pizza with Pepperoni and one',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: '$5 Lunch Combo Aquafina (1390 Cal)',
      itemName: '$5 Lunch Combo Aquafina',
      itemType: 'DDD',
      maxToppings: 0,
      menuItemCode: 'HNR-SSLAQ',
      menuWarnings: [{
        id: 'Sodium',
        name: 'Sodium',
        url: 'https://mobileblobfiles.blob.core.windows.net/menuwarningimages/NYC-sodium-warning-label-lg.jpg',
        altText: 'High Sodium',
        displayOrder: 0,
        warningText: 'Warning indicates that the sodium (salt) content of this item is higher than the total'
      }],
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }],
    itemType: 'DDD',
    typeDescription: 'Detroit-Style Deep Dish Pizzas'
  }, {
    menuItems: [{
      calories: 840,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: '',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/a73b7fed-519e-4ac8-b7b5-651c76321432.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/a73b7fed-519e-4ac8-b7b5-651c76321432.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 601006,
      itemCaloriesText: '840 Cal',
      itemDescription: 'Eight bread sticks with',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Crazy Combo® [Crazy Bread® & Crazy Sauce®] (840 Cal)',
      itemName: 'Crazy Combo® [Crazy Bread® & Crazy Sauce®]',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-CCOMBO',
      menuWarnings: null,
      orderable: true,
      price: 3,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 800,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/72ac10fb-4f2b-48f1-8259-f2bcda08ce1c.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/72ac10fb-4f2b-48f1-8259-f2bcda08ce1c.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 103001,
      itemCaloriesText: '800 Cal',
      itemDescription: 'Eight bread sticks with flavors of butter and garlic, then sprinkled with parmesan cheese',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Crazy Bread® (800 Cal)',
      itemName: 'Crazy Bread®',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-CRZB',
      menuWarnings: null,
      orderable: true,
      price: 2.75,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 30,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e4370491-8faf-4e9b-8ef8-0fb1c57aefb0.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e4370491-8faf-4e9b-8ef8-0fb1c57aefb0.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 103002,
      itemCaloriesText: '30 Cal',
      itemDescription: 'Tomato dipping sauce with a special blend of tasty herbs and spices',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Crazy Sauce® (30 Cal)',
      itemName: 'Crazy Sauce®',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-CRZS',
      menuWarnings: null,
      orderable: true,
      price: 1,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 800,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/cc2e2c53-ee15-430c-b90a-b04820316319.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/cc2e2c53-ee15-430c-b90a-b04820316319.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 101289,
      itemCaloriesText: '800 Cal',
      itemDescription: 'Brownie topped with Cookie Dough Frosting and TWIX® Cookie Bar Pieces | 4-piece order',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Cookie Dough Brownie made with TWIX® Cookie Bar Pieces (800 Cal)',
      itemName: 'Cookie Dough Brownie made with TWIX® Cookie Bar Pieces',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-KDBTWX',
      menuWarnings: null,
      orderable: true,
      price: 3.89,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 840,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e7741f5f-e5e1-4b59-a395-c6e6714c1a44.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e7741f5f-e5e1-4b59-a395-c6e6714c1a44.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 101288,
      itemCaloriesText: '840 Cal',
      itemDescription: 'Brownie topped with Cookie Dough Frosting and M&M’S® MINIS',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Cookie Dough Brownie made with M&M’S® MINIS Chocolate Candies (840 Cal)',
      itemName: 'Cookie Dough Brownie made with M&M’S® MINIS Chocolate Candies',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-CDBMM',
      menuWarnings: null,
      orderable: true,
      price: 3.89,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1820,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/a8d5cb4d-88f7-44ed-bb91-412e96b14af1.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/a8d5cb4d-88f7-44ed-bb91-412e96b14af1.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 203028,
      itemCaloriesText: '1820 Cal',
      itemDescription: 'A family size version of our Crazy Bites tossed in cinnamon and sugar',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Cinnamon Crazy Bites™ (1820 Cal)',
      itemName: 'Cinnamon Crazy Bites™',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-LCBCF',
      menuWarnings: null,
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1520,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/0ffd2dad-f443-4190-9b96-43e8b1efec48.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/0ffd2dad-f443-4190-9b96-43e8b1efec48.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 203004,
      itemCaloriesText: '1520 Cal',
      itemDescription: 'Ten pieces of freshly baked bread with crispy edge',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Pepperoni Cheese Bread (1520 Cal)',
      itemName: 'Pepperoni Cheese Bread',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-10PCB',
      menuWarnings: null,
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 1340,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/72bf4d8e-a236-416c-8922-8f6202dfdca1.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/72bf4d8e-a236-416c-8922-8f6202dfdca1.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 103003,
      itemCaloriesText: '1340 Cal',
      itemDescription: 'Ten pieces of freshly baked bread with a crispy edge',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Italian Cheese Bread (1340 Cal)',
      itemName: 'Italian Cheese Bread',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-ICB',
      menuWarnings: null,
      orderable: true,
      price: 4,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 510,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f38a2bb8-a751-4c64-9dfa-8be5ddef7b71.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f38a2bb8-a751-4c64-9dfa-8be5ddef7b71.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 105001,
      itemCaloriesText: '510 Cal',
      itemDescription: 'Traditionally seasoned oven roasted wings',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Caesar Wings® – Oven Roasted (510 Cal)',
      itemName: 'Caesar Wings® – Oven Roasted',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-ORCW',
      menuWarnings: null,
      orderable: true,
      price: 7.55,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 620,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/05de1761-86e9-4e32-970c-7c23950ce947.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/05de1761-86e9-4e32-970c-7c23950ce947.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 105001,
      itemCaloriesText: '620 Cal',
      itemDescription: 'Oven roasted wings with a sweet traditional BBQ sauce',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Caesar Wings® – BBQ (620 Cal)',
      itemName: 'Caesar Wings® – BBQ',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-BBQCW',
      menuWarnings: null,
      orderable: true,
      price: 7.55,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 510,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/1ca48391-a057-460a-9056-b1c801310dab.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/1ca48391-a057-460a-9056-b1c801310dab.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 105001,
      itemCaloriesText: '510 Cal',
      itemDescription: 'Oven roasted wings with a hot Buffalo wing sauce',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Caesar Wings® – Buffalo (510 Cal)',
      itemName: 'Caesar Wings® – Buffalo',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-BUFCW',
      menuWarnings: null,
      orderable: true,
      price: 7.55,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 660,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d888a65b-a46d-4945-9233-72248db797b2.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d888a65b-a46d-4945-9233-72248db797b2.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 105001,
      itemCaloriesText: '660 Cal',
      itemDescription: 'Oven roasted wings with a creamy Garlic Parmesan sauce',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Caesar Wings® – Garlic Parmesan (660 Cal)',
      itemName: 'Caesar Wings® – Garlic Parmesan',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'HNRS-GPCW',
      menuWarnings: null,
      orderable: true,
      price: 7.55,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 370,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f8e483a5-62fe-4af4-8bee-b21699adfaf2.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f8e483a5-62fe-4af4-8bee-b21699adfaf2.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 206103,
      itemCaloriesText: '370 Cal',
      itemDescription: 'Butter and garlic flavored dipping sauce',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Caesar Dips® - Butter Garlic Flavor (370 Cal)',
      itemName: 'Caesar Dips® - Butter Garlic Flavor',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'SIDE-BGCD',
      menuWarnings: null,
      orderable: true,
      price: 1.83,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 230,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/b9bbf3fe-06e5-4ecf-9eed-7eea6f1ccdc0.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/b9bbf3fe-06e5-4ecf-9eed-7eea6f1ccdc0.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 206101,
      itemCaloriesText: '230 Cal',
      itemDescription: 'Flavorful Buffalo ranch dipping sauce',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Caesar Dips® - Buffalo Ranch (230 Cal)',
      itemName: 'Caesar Dips® - Buffalo Ranch',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'SIDE-BUFRCD',
      menuWarnings: null,
      orderable: true,
      price: 1.83,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 220,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d7438ebf-371d-4d57-82f2-a7b02eb24920.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d7438ebf-371d-4d57-82f2-a7b02eb24920.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 206108,
      itemCaloriesText: '220 Cal',
      itemDescription: 'Flavorful cheesy-jalapeño dipping sauce',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Caesar Dips® - Cheezy Jalapeño (220 Cal)',
      itemName: 'Caesar Dips® - Cheezy Jalapeño',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'SIDE-CJCD',
      menuWarnings: null,
      orderable: true,
      price: 0.59,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 240,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/6e55ef14-2f2b-4b2b-b28b-5e2f02daff8e.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/6e55ef14-2f2b-4b2b-b28b-5e2f02daff8e.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 206104,
      itemCaloriesText: '240 Cal',
      itemDescription: 'Flavorful ranch dipping sauce',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Caesar Dips® - Ranch (240 Cal)',
      itemName: 'Caesar Dips® - Ranch',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'SIDE-RCD',
      menuWarnings: null,
      orderable: true,
      price: 0.59,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 90,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/2aa73332-6f94-4381-b7b6-15a93bf99877.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/2aa73332-6f94-4381-b7b6-15a93bf99877.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 206128,
      itemCaloriesText: '90 Cal',
      itemDescription: 'Flavorful Cheddar Cheese dipping sauce',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Cheddar Cheese Sauce (90 Cal)',
      itemName: 'Cheddar Cheese Sauce',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'SIDE-CCDPP',
      menuWarnings: null,
      orderable: true,
      price: 1.29,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 0,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Side',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/db109555-7f88-45e7-9b8d-4825e12d9b59.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/db109555-7f88-45e7-9b8d-4825e12d9b59.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 207009,
      itemCaloriesText: '',
      itemDescription: 'Iceberg/Romaine lettuce blend, seasoned croutons, shredded cheese, tomatoes, shredded carrots',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Garden Salad',
      itemName: 'Garden Salad',
      itemType: 'HNRS',
      maxToppings: 0,
      menuItemCode: 'SIDE-GMSL',
      menuWarnings: null,
      orderable: true,
      price: 5,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }],
    itemType: 'HNRS',
    typeDescription: 'Sides'
  }, {
    menuItems: [{
      calories: 850,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/c2829b1f-2f4e-475d-a4a9-ddb7983f4dc4.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/c2829b1f-2f4e-475d-a4a9-ddb7983f4dc4.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204200,
      itemCaloriesText: '850 Cal',
      itemDescription: '2-liter bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®. affiliated companies.',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Pepsi 2 Liter (850 Cal)',
      itemName: 'Pepsi 2 Liter',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-2LPEP',
      menuWarnings: null,
      orderable: true,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 960,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/b1877211-019a-4f09-859b-734ae0713a06.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/b1877211-019a-4f09-859b-734ae0713a06.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204200,
      itemCaloriesText: '960 Cal',
      itemDescription: '2-liter bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Mountain Dew 2 Liter (960 Cal)',
      itemName: 'Mountain Dew 2 Liter',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-2LMDEW',
      menuWarnings: null,
      orderable: true,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 790,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f6c1cc79-705e-4407-b957-2d54ca3eca78.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f6c1cc79-705e-4407-b957-2d54ca3eca78.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204200,
      itemCaloriesText: '790 Cal',
      itemDescription: '2-liter bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Sierra Mist 2 Liter (790 Cal)',
      itemName: 'Sierra Mist 2 Liter',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-2LMT',
      menuWarnings: null,
      orderable: true,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 0,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/c277a910-38ae-4ebf-8a9c-9c43ac13ff88.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/c277a910-38ae-4ebf-8a9c-9c43ac13ff88.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204200,
      itemCaloriesText: '',
      itemDescription: '2-liter bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Diet Pepsi 2 Liter',
      itemName: 'Diet Pepsi 2 Liter',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-2LDPEP',
      menuWarnings: null,
      orderable: true,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 250,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/9c279c65-8972-4aac-91ac-47cf7d7b7086.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/9c279c65-8972-4aac-91ac-47cf7d7b7086.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204100,
      itemCaloriesText: '250 Cal',
      itemDescription: '20 oz. bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Pepsi 20 oz. (250 Cal)',
      itemName: 'Pepsi 20 oz.',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-20OZPEP',
      menuWarnings: null,
      orderable: true,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 290,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/5036c163-c469-46ea-833b-d3be09bbfecb.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/5036c163-c469-46ea-833b-d3be09bbfecb.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204100,
      itemCaloriesText: '290 Cal',
      itemDescription: '20 oz. bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Mountain Dew 20 oz. (290 Cal)',
      itemName: 'Mountain Dew 20 oz.',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-20OZMDEW',
      menuWarnings: null,
      orderable: true,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 240,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/2568c50f-22be-459a-a756-50d29381f0b1.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/2568c50f-22be-459a-a756-50d29381f0b1.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204100,
      itemCaloriesText: '240 Cal',
      itemDescription: '20 oz. bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Sierra Mist 20 oz. (240 Cal)',
      itemName: 'Sierra Mist 20 oz.',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-20OZMT',
      menuWarnings: null,
      orderable: true,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 0,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/bcb6716d-df5c-47a3-a91a-8f39fd135350.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/bcb6716d-df5c-47a3-a91a-8f39fd135350.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204100,
      itemCaloriesText: '',
      itemDescription: '20 oz. bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'Diet Pepsi 20 oz.',
      itemName: 'Diet Pepsi 20 oz.',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-20OZDPEP',
      menuWarnings: null,
      orderable: true,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 2380,
      caloriesRange: '0 – 2380',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/83100039-37a2-4495-a72b-35e0ec021593.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/83100039-37a2-4495-a72b-35e0ec021593.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204200,
      itemCaloriesText: '0 – 2380 Cal',
      itemDescription: '2-liter bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'PEPSI-COLA® Products - 2 Liter (0 – 2380 Cal)',
      itemName: 'PEPSI-COLA® Products - 2 Liter',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-2LTR',
      menuWarnings: null,
      orderable: false,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 140,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/18b137c6-c970-46d8-be38-11302e11a783.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/18b137c6-c970-46d8-be38-11302e11a783.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204100,
      itemCaloriesText: '140 Cal',
      itemDescription: '20 oz. bottles of PEPSI®, DIET PEPSI®, MOUNTAIN DEW®, SIERRA MIST®',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'PEPSI-COLA® Products - 20 oz. (140 Cal)',
      itemName: 'PEPSI-COLA® Products - 20 oz.',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-20OZ',
      menuWarnings: null,
      orderable: false,
      price: 1.79,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }, {
      calories: 0,
      caloriesRange: '',
      comment: '',
      crustImages: null,
      favoriteId: 0,
      favoriteName: null,
      foodGroup: 'Drink',
      id: 0,
      images: [{
        imageAltText: '',
        imageType: 'Web_ItemDetailImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/735f6b77-3e29-422c-9ad5-4d6f21c38561.jpg'
      }, {
        imageAltText: '',
        imageType: 'Web_MenuImage',
        imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/735f6b77-3e29-422c-9ad5-4d6f21c38561.jpg'
      }],
      isCustomMenuItem: false,
      itemId: 204301,
      itemCaloriesText: '',
      itemDescription: '20 oz. AQUAFINA®   All beverage-related trademarks',
      itemDescriptionWithCalories: null,
      itemNameWithCalories: 'AQUAFINA® 20 oz.',
      itemName: 'AQUAFINA® 20 oz.',
      itemType: 'CNR',
      maxToppings: 0,
      menuItemCode: 'CNR-AQ20OZ',
      menuWarnings: null,
      orderable: true,
      price: 1.59,
      selectedCustomOptions: null,
      selectedToppings: null,
      toppingsThresholdCount: 0,
      toppingsThresholdMessage: null,
      servings: ''
    }],
    itemType: 'CNR',
    typeDescription: 'Drinks'
  }]
};
exports.mockMenu = mockMenu;